import { getStorage, ref, getDownloadURL } from "firebase/storage";
// import { ref, getDownloadURL, uploadBytes } from "firebase/storage"

import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
import { getApp } from "firebase/app";
import firebase from "../../firebase/config";

export const fetchCiqualCategories = () => {
  return (dispatch, getState, { getFirebase }) => {
    // RESOLVE CORSE ERROR (authorize local hots on gcloud) : https://stackoverflow.com/questions/37760695/firebase-storage-and-access-control-allow-origin
    console.log("[START FETCH CATEGORIES]");
    const storage = getFirebase().storage();
    // console.log("storage", storage);
    const pathReference = ref(storage, "ciqual_categories/ciqual_categories.json");
    // console.log("pathReference", pathReference);
    getDownloadURL(pathReference).then(async (url) => {
      const resp = await fetch(url);
    //   console.log("resp", resp);
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log("[END FETCH CATEGORIES] - RESULTS:", json);
          dispatch({ type: "FETCH_CIQUAL_CATEGORIES", payload: json });
        })
        .catch((error) => console.error(error));
    });
  };
};
